<template>
    <div class="filter-wrapper">

        <v-snackbar
                :absolute="true"
                v-model="notification"
                :color="'success'"
                :multi-line="false"
                :timeout="3000"
                :vertical="false"
                :bottom="true">

            {{ notification_message }}

            <v-btn  text @click="notification = false">
                Close
            </v-btn>

        </v-snackbar>

        <v-form model="filter_form"
                v-on:keyup.enter="process_form()"
                ref="form"
                @submit="process_form()"
                onSubmit="return false;"
                lazy-validation="">

            <v-layout row wrap align-center justify-center fill-height>

                <v-flex xs12 md3 sm2 v-for="(field, key) in fields_to_filter" :key="key" height="64" class="mx-1">

                    <div v-if="field.type === 'text' || field.type === 'number' || field.type === 'email' || field.type === 'password'">
                        <v-text-field
                                style="margin-top:20px;"
                                :class="{ 'is-invalid': submitted && errors.has(field.table) }"
                                :name="field.table"
                                v-validate="'required'"
                                v-model="field.value"
                                :rules="field.rules"
                                :label="field.label"
                                :type="field.type"
                                :required="field.required"
                        ></v-text-field>
                    </div>

                    <div v-if="field.type === 'textarea'">
                        <v-textarea
                                :class="{ 'is-invalid': submitted && errors.has(field.table) }"
                                :name="field.table"
                                v-validate="'required'"
                                v-model="field.value"
                                :rules="field.rules"
                                :label="field.label"
                                :required="field.required"
                        ></v-textarea>
                    </div>

                    <div v-if="field.type === 'select'" style="margin:20px 0;">
                        <v-select
                                :class="{ 'is-invalid': submitted && errors.has(field.table) }"
                                :name="field.table"
                                v-validate="'required'"
                                v-model="field.value"
                                :items="field.options"
                                :item-value="field.track_by"
                                :item-text="field.show"
                                :label="field.label"
                                :required="field.required"
                                required=""
                                hide-details>
                        </v-select>
                    </div>
                    <div v-if="field.type === 'hidden'">
                        <input type="hidden" v-model="field.value">
                    </div>

                </v-flex>
                <v-flex shrink>
                    <v-btn class="mt-1" rounded text fab
                           color="success"
                           @click="process_form()">
                        <v-icon>
                            mdi-magnify
                        </v-icon>
                    </v-btn>
                </v-flex>

            </v-layout>
        </v-form>

    </div>
</template>

<script>
    export default {
        name: 'FilterData',
        props: {
            original_url: String,
            fields_to_filter: Array,
        },
        data() {
            return {
                processed_data: [],
                notification: false,
                notification_message: '',
                submitted: false
            }
        },
        methods: {
            triggerNewSearch (url) {
                //Trigger with null to reset table
                return this.$emit('trigger-new-search', url);
            },

            process_form() {
                this.submitted = true;

                if (!this.$validator.validate()) {
                    console.log("invalid");
                    this.notification = true;
                    this.notification_message = 'Please fill in all required inputs';
                    return;
                }

                let _url = this.original_url;

                /**
                 * Search through the url for [tablename] and replace it
                 * with the value.
                 */
                for(let field of this.fields_to_filter){
                    if (field.value === '') field.value = '*';
                    _url = _url.replace('[' + field.table + ']', field.value)
                }


                this.triggerNewSearch(_url);

            },

        }
    }
</script>
